/**
 * Shared API client for the testing app.
 *
 * Built on `@configural/platform` — all requests automatically inject
 * `x-subtenant-id` (from the current hierarchy selection) when one is set.
 *
 * The legacy surface (`apiGet`/`apiPost`/`apiPut`/`apiDelete`) is preserved
 * so the feature modules under ./ don't need to change. New code is
 * encouraged to import `client` directly and use `client.get/post/...`.
 */

import { createClient, headerFromGetter, ApiError } from "@configural/platform/api-client";

let currentSubTenantId = null;

export function setCurrentSubTenant(id) {
  currentSubTenantId = id || null;
}

export function getCurrentSubTenant() {
  return currentSubTenantId;
}

// Single shared client — baseUrl is empty because the existing feature
// modules build absolute-from-root paths (e.g. "/api/v1/patients") and we
// don't want to break that. The subtenant header provider is mutable
// through `setCurrentSubTenant()` above; the provider captures the
// getter, so every request reads the current value.
export const client = createClient({
  baseUrl: "",
  credentials: "include",
  headers: [headerFromGetter(() => currentSubTenantId, "x-subtenant-id")],
});

// ─── Legacy surface ─────────────────────────────────────────────────────

export const apiGet = (path) => client.get(path);
export const apiPost = (path, body) => client.post(path, { body });
export const apiPut = (path, body) => client.put(path, { body });
export const apiDelete = (path) => client.del(path);

// Re-export ApiError so callers can `instanceof`-check consistently.
export { ApiError };
